import { createQueryKeys } from "@lukemorales/query-key-factory";
import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";

import { api, baseApiUrl } from "@/lib/api";
import { type Tenant } from "@/types";

export const tenant = createQueryKeys("tenant", {
  tenant: null,
});

export const fetchTenantQueryOptions = () =>
  queryOptions({
    queryKey: [tenant.tenant],
    queryFn: () =>
      api.get<Tenant>(baseApiUrl + `/tenant`).then((response) => response.data),
  });

export const useFetchTenant = () => {
  return useQuery(fetchTenantQueryOptions());
};

export const useTenant = () => {
  const { data } = useSuspenseQuery(fetchTenantQueryOptions());
  return data;
};
